import { Component } from 'react'
import { Field, reduxForm } from 'redux-form'
import submit from './submit.js'
import Input from '../../Form/Field/Input.jsx'
import validate from './validate.js'
import FormGlobalErrors from '../../Form/FormGlobalErrors.jsx'
import Loader from '../../../../shared/components/Loader/Loader.jsx'
import createOnSubmitFailHandler from '../../Form/createOnSubmitFailHandler.js'

export const name = 'ForgottenPasswordForm'

class ForgottenPasswordForm extends Component {
  constructor(props) {
    super(props)
    if (props.data) {
      props.initialize(props.data)
    }
  }

  render() {
    return (
      <div id={name} className="forgotten-password-form">
        <form onSubmit={this.props.handleSubmit}>
          <FormGlobalErrors errors={this.props.error}></FormGlobalErrors>
          <Field
            label="Email*"
            name="email"
            component={Input}
            type="text"
            placeholder="john@doe.fr" />
        </form>
        <Loader visible={this.props.submitting || this.props.triggerSubmit}></Loader>
      </div>
    )
  }
}

export default reduxForm({
  form: name,
  onSubmit: submit,
  onSubmitFail: createOnSubmitFailHandler(name),
  validate
})(ForgottenPasswordForm)